module.exports = new __parcel__URL__("duck.e8819dfa.svg").toString();